export default __webpack_public_path__ + "static/media/IBEW-use-fontawesome_calendar-days-ico.c13bdefb.svg";